export default __webpack_public_path__ + "static/media/GraceImage.ca40a4a7.png";